import { render, staticRenderFns } from "./SalesOrderTracking.vue?vue&type=template&id=1bb8990e&"
import script from "./SalesOrderTracking.vue?vue&type=script&lang=ts&"
export * from "./SalesOrderTracking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bb8990e')) {
      api.createRecord('1bb8990e', component.options)
    } else {
      api.reload('1bb8990e', component.options)
    }
    module.hot.accept("./SalesOrderTracking.vue?vue&type=template&id=1bb8990e&", function () {
      api.rerender('1bb8990e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/SalesOrderTracking.vue"
export default component.exports